# ---
# Глобальная шина событий общего назначения
# Служит для обмена произвольными событиями совершенно разных компонентов приложения
# ---
MediatorService = Em.Service.extend(Em.Evented)
module.exports = MediatorService